const emptyGift = {
    giftId: '',
    startDate: null,
    endDate: null,
    requiredVersion: 1,
    releaseNumber: '',
};

export default emptyGift;
